import { Supplier } from "../../../../interfaces/pharmacy";

export const mockSuppliers: Supplier[] = [
  {
    id: "SUP-001",
    name: "Lebanese Drug Corp",
    contactPerson: "Mr. Jean El-Khoury",
    phone: "+961 1 234 567",
    email: "orders@ldc.com.lb",
    address: "LDC Building, Beirut Central District, Beirut, Lebanon",
  },
  {
    id: "SUP-002",
    name: "Pharma International",
    contactPerson: "Ms. Fatima Al-Masri",
    phone: "+961 3 876 543",
    email: "contact@pharma-intl.com",
    address: "Pharma Tower, Sin El Fil, Lebanon",
  },
  {
    id: "SUP-003",
    name: "General Medical Supplies",
    contactPerson: "Mr. George Haddad",
    phone: "+961 5 987 654",
    email: "info@gms-lebanon.com",
    address: "Industrial Zone, Mkalles, Lebanon",
  },
]; 